import { bytesToGB, bytesToKB, bytesToMB } from "math";

export const formatBytes = (b: number): string => {
  const ONE_KILOBYTE = 1000;
  const ONE_MEGABYTE = 1000000;
  const ONE_GIGABYTE = 1000000000;

  const fixed = (x: number): number => Math.floor(x);
  
  if (b >= ONE_GIGABYTE) {
    const val = fixed(bytesToGB(b));
    return `${val} GB`;
  }

  if (b >= ONE_MEGABYTE) {
    const val = fixed(bytesToMB(b));
    return `${val} MB`;
  }

  if (b >= ONE_KILOBYTE) {
    const val = fixed(bytesToKB(b));
    return `${val} KB`;
  }
  return `${b} Bytes`;
}
